import React from "react";

import "./homepage.style.scss";

import Directory  from "../../components/directory/directory.component";

const HomePage = () => (
    <div className="homepage">
        <Directory />
    </div>
);

export default HomePage;